import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FormattedMessage } from "react-intl";
import {TableFilterInternal} from "../filter-tools/filter-tools-view";

export interface NoDataIndicatorProps<D> {
  data?: D[];
  disableLoadingIndicator?: boolean;
  loadFailed?: boolean;
  search?: boolean;
  activeSearch?: string;
  onSearch?: (s: string) => void;
  filters?: TableFilterInternal[] | undefined;
}

export default function NoDataIndicator<D>(props: NoDataIndicatorProps<D>) {
  const {
    data,
    disableLoadingIndicator,
    loadFailed,
    search,
    activeSearch,
    onSearch,
    filters,
  } = props;
  const hasSearch = !!(search && activeSearch && activeSearch.length);
  const hasFilter = !!(filters && filters.filter((f) => f.isActive === true).length)
  return (
    <div className={"no-data-indicator-cell text-muted"}>
      {data === undefined && !disableLoadingIndicator && !loadFailed ? (
        <span data-test-table-loading>
          <FontAwesomeIcon
            icon={"spinner"}
            spin
            size={"3x"}
            className={"opacity-50"}
          />
        </span>
      ) : undefined}
      {data !== undefined && !loadFailed && (
        <div data-test-table-empty-alert>
          <h4 className={"mb-0"}>
            <div className={"icon"}>
                <span className="fa-layers fa-fw fa-2x">
                  <FontAwesomeIcon
                      icon="circle"
                      mask={"database"}
                      className={"opacity-50"}
                      transform="shrink-0 right-5 down-5"
                  />
                  <FontAwesomeIcon
                      icon="ban"
                      transform="shrink-4 right-5 down-5"
                  />
                </span>
            </div>
          {(!hasSearch && !hasFilter) &&(
              <div>
                <FormattedMessage
                  defaultMessage="No results to show."
                  description="message to be shown when the table is empty and there is no active search/filter"
                />
              </div>
          )}
          {(hasSearch || hasFilter) && (
                <div>
                  <FormattedMessage
                    defaultMessage="No matching results to show"
                    description="title to be shown when the table is empty and there is an active search/filter"
                  />
                </div>
          )}
          </h4>
          {(hasSearch || hasFilter) && (
              <p className={"mb-0"}>
                {hasSearch && (
                    <button
                        type="button"
                        className={"btn btn-theme-to-primary"}
                        onClick={() => {
                          if (onSearch) {
                            onSearch("");
                          }
                        }}
                    >
                      <FormattedMessage
                          defaultMessage="Clear active search"
                          description="clear search button label to be shown when the table is empty and there is an active search/filter"
                      />
                    </button>
                )}
                {hasFilter && (
                    <button
                        type="button"
                        className={"btn btn-theme-to-primary"}
                        onClick={() => {
                          if (filters) {
                            filters.forEach((f) => {
                              if (f.isActive) {
                                f.handler(false);
                              }
                            })
                          }
                        }}
                    >
                      <FormattedMessage
                          defaultMessage="Clear filters"
                          description="clear filters button label to be shown when the table is empty and there is an active filter"
                      />
                    </button>
                )}
              </p>
          )}
        </div>
      )}
      {data === undefined && loadFailed && !disableLoadingIndicator && (
        <>
          <h4 className={"mb-0 text-danger"}>
            <div className={"icon"}>
              <span className="fa-layers fa-fw fa-2x">
                <FontAwesomeIcon
                  icon="exclamation-triangle"
                  mask={"database"}
                  className={"opacity-50"}
                  transform="shrink-0 right-5 down-5"
                />
                <FontAwesomeIcon
                  icon="exclamation-triangle"
                  transform="shrink-4 right-5 down-5"
                />
                <span className={"exclamation-mask"}></span>
                <FontAwesomeIcon
                  icon="exclamation-triangle"
                  transform="shrink-4 right-5 down-5"
                />
              </span>
            </div>
            <div>
              <FormattedMessage
                defaultMessage="Loading failed"
                description="message to be shown when the table is empty and there's been a loading error"
              />
            </div>
          </h4>
          <p className={"mb-0 text-danger"}>
            <FormattedMessage
              defaultMessage="Please try again, if the problem persists contact your administrator."
              description="Message to be shown when the table is empty and there's been a loading error. The administrator here is not the same as the 'admin' used elsewhere, different translation is preferred. This refers to a person responsible for deploying and managing this application."
            />
          </p>
        </>
      )}
    </div>
  );
}
